import React from 'react';

const SpeedTestSection = () => {
  const speedComparison = [
    { provider: 'Provider A', speed: '25 Mbps', color: 'bg-red-500', width: '25%' },
    { provider: 'Provider B', speed: '50 Mbps', color: 'bg-yellow-500', width: '50%' },
    { provider: 'Kami', speed: '300 Mbps', color: 'bg-gradient-to-r from-green-500 to-blue-500', width: '100%' }
  ];

  return (
    <section className="py-16">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-4">Rasakan Perbedaan Kecepatan</h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto mb-8">
            Bandingkan kecepatan internet kami dengan provider lain
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {speedComparison.map((item, index) => (
            <div key={index} className="text-center">
              <h3 className="text-xl font-bold mb-4">{item.provider}</h3>
              <div className="bg-gray-700 rounded-full h-8 mb-4 overflow-hidden">
                <div 
                  className={`${item.color} h-full rounded-full speed-indicator transition-all duration-2000`}
                  style={{ width: item.width }}
                ></div>
              </div>
              <div className="text-2xl font-bold text-blue-400">{item.speed}</div>
              <div className="text-gray-400">Download Speed</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SpeedTestSection;